export default __webpack_public_path__ + "static/ubuntu-0dfd9d23ad0effe494e6e60267c9cae7.png";